module.exports = __webpack_public_path__ + "img/collection-memoireRingsSlim.e6e34a7.webp";